import { SortByType } from '@/domain/search/constants'
import { Configure } from '@/domain/search/types'

/**
 * Distance precision in meters when sorting by distance
 * Algolia's minimum precision is 10 meters
 * This is critical for distance sorting to work correctly to keep it low as possible else, groupings will be off.
 */
export const DISTANCE_SORT_PRECISION = 10

/**
 * Applies sort-specific configuration overrides to searchState.configure
 * Centralizes the logic for handling sort-specific settings like aroundPrecision
 *
 * @param {Object} configure - The configuration object to modify
 * @param {string} sortBy - The sort type (SortByType.Distance, SortByType.Relevance, etc.)
 * @param {number} [defaultPrecision] - Default precision to use for non-overridden sorting
 * @returns {Object} Updated configuration with sort-specific overrides applied
 */
export const applySortConfiguration = (
  configure: Configure,
  sortBy: SortByType,
  defaultPrecision?: number
) => {
  switch (sortBy) {
    case SortByType.Distance:
      return {
        ...configure,
        aroundPrecision: DISTANCE_SORT_PRECISION
      }

    default:
      return {
        ...configure,
        ...(defaultPrecision !== undefined && {
          aroundPrecision: defaultPrecision
        })
      }
  }
}
